module.exports = __webpack_public_path__ + "static/media/Upload_Sample_w_ASIN.4ff325db.csv";